import { isCompleteAddress } from '@/componentsV1/BaseComponents/LocationSearchInput'
import { TaxChecklistResponseValue } from '../../taxChecklistQuestion.slice'

export const HOME_ADDRESS_STATUS = {
  missing: 'missing',
  incomplete: 'incomplete',
  complete: 'complete',
} as const

export type HomeAddressStatus =
  (typeof HOME_ADDRESS_STATUS)[keyof typeof HOME_ADDRESS_STATUS]

/** Status of the address the step opens with: this form's answer, else the profile's. */
export const getHomeAddressStatus = (
  savedAnswer: TaxChecklistResponseValue | undefined,
  profileAddress: string | null | undefined
): HomeAddressStatus => {
  const address = savedAnswer ?? profileAddress
  if (typeof address !== 'string' || !address.trim()) {
    return HOME_ADDRESS_STATUS.missing
  }
  return isCompleteAddress(address)
    ? HOME_ADDRESS_STATUS.complete
    : HOME_ADDRESS_STATUS.incomplete
}
